import { createSlice } from "@reduxjs/toolkit";

const getStoredLanguageCode = () => localStorage.getItem("language") || "ar";

const initialState = {
  language: getStoredLanguageCode() === "ar" ? "العربية" : "English",
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    toggleLanguage: (state) => {
      state.language = state.language === "English" ? "العربية" : "English";
      localStorage.setItem(
        "language",
        state.language === "English" ? "en" : "ar",
      );
    },
  },
});

export const { toggleLanguage } = languageSlice.actions;
export default languageSlice.reducer;
